(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-data/assets/javascripts/actions/initialize-component-state.js') >= 0) return;  svs.modules.push('/components/chat/chat-data/assets/javascripts/actions/initialize-component-state.js');

'use strict';

const CHAT_INITIALIZE_COMPONENT_STATE = 'CHAT/CHAT_INITIALIZE_COMPONENT_STATE';
setGlobal('svs.components.chat.chatData.actions.CHAT_INITIALIZE_COMPONENT_STATE', CHAT_INITIALIZE_COMPONENT_STATE);

 })(window);